<template>
    <div class="invoice-list">
        <status-tabs :status.sync="status" :statusList="statusList" :funcName="funcName"></status-tabs>

        <search-tool ref="searchTool" :status="status" :statusList="statusList" :funcName="funcName"
            :searchForm="searchForm" :searchList="searchList" :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields" listName="invoice" :loading="loading" :inputPlaceholder="inputPlaceholder" :selected="selectList.length">
        </search-tool>

        <div class="table" :style="{ height: height }">
            <el-table :data="tableData" ref="tableData" height="100%" row-key="id"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column align="left" label="Invoice No." prop="invoice_no">
                </el-table-column>
                <el-table-column align="left" label="Issue Date" prop="issue_date">
            <template slot-scope="scope">
                {{ formatDate(scope.row.issue_date) }}
            </template>
        </el-table-column>
                <el-table-column align="left" label="Invoice Period">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.billing_start_date) }} - {{ formatDate(scope.row.billing_end_date) }}
                    </template>
                </el-table-column>
                <el-table-column align="right" label="Total Amount" prop="total_amount">
                    <template slot-scope="scope">
                        <div class="col-amount">
                            {{ '$' + formatAmount(scope.row.total_amount) }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column align="center" label="Action" width="140">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="downloadInvoice(scope.row)" :loading="scope.row.downloading">
                            <i class="el-icon-download"></i>
                            Download
                        </el-button>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination :paginationData="paginationData" @paginationChange="paginationChange" :funcName="funcName">
        </pagination>

        <InvoicePreview
            :visible.sync="previewVisible"
            :current-invoice="currentInvoice"
        />
    </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import InvoicePreview from "./invoice/preview.vue";
import tools from "@/utils/tools.js";

export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Invoice No.、Invoice Period、Company",
            searchForm: {
                keyword: "",
                start_date: "",
                end_date: "",
            },
            searchForm_transfer: {},
            funcName: "invoice",
            selectList: [],
            previewVisible: false,
            currentInvoice: {},
            exporting: false,
            advanceSearchFields: {
                start_date: {
                    label: "Start Date",
                    type: "date",
                },
                end_date: {
                    label: "End Date",
                    type: "date",
                },
            },
        };
    },
    methods: {

        invoice(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .invoice(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        clean() {
            this.searchForm = {
                keyword: "",
                start_date: "",
                end_date: "",
            };
            this.searchForm_transfer = {};
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.invoice();
        },
        downloadInvoice(row) {
            this.$set(row, 'downloading', true);
            cmofferApi.invoiceDetail({}, 'get', row.id).then(res => {
                if (res) {
                    this.currentInvoice = res.data;
                    this.previewVisible = true;
                }
                this.$set(row, 'downloading', false);
            }).catch(() => {
                this.$set(row, 'downloading', false);
            });
        },
        formatAmount(amount) {
            if (amount === null || amount === undefined || amount === "") {
                return "0.00";
            }
            return parseFloat(amount).toFixed(2);
        },
        formatDate(date) {
            return tools.formatDate(date);
        },

    },
    activated() {
        this.initialize();
    },
    components: {
        InvoicePreview
    },
    computed: {
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "开始日期" : "Start Date",
                    key: "start_date",
                    type: "date",
                    props: {
                        type: "date",
                        format: "yyyy-MM-dd",
                        valueFormat: "yyyy-MM-dd",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "结束日期" : "End Date",
                    key: "end_date",
                    type: "date",
                    props: {
                        type: "date",
                        format: "yyyy-MM-dd",
                        valueFormat: "yyyy-MM-dd",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }
                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.invoice-list {
    width: 100%;
    height: 100%;
    background: #fff;

    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;
        height: calc(100% - 120px);

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }

        .col-amount {
            color: var(--col-color);
            font-weight: 600;
        }
    }


}
</style>
